module.exports = __webpack_public_path__ + "img/uc_carsharing_roxo.d0a3bd30.png";